import qs from 'qs';

// Логи с удаленного сервера
const LogServer = {
    namespaced: true,

    state: {
        LogsServerData: [],
        jsonLogServerData: [],
        errorLogServerData: [],
    },

    getters: {
        LogsServerData (state) {
            return state.LogsServerData;
        },
        jsonLogServerData (state) {
            return state.jsonLogServerData;
        },
        errorLogServerData (state) {
            return state.errorLogServerData;
        },
    },
     
    mutations: {

        /**
         * Установить значение объекта
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['LogsServerData'] = items;
        },
        /**
         * Установить значение объекта
         * @param state
         * @param items
         */
        setArrJson (state, { items }) {
            state['jsonLogServerData'] = items;
        },
        /**
         * Установить значение объекта
         * @param state
         * @param items
         */
        setArrError (state, { items }) {
            state['errorLogServerData'] = items;
        },

        /**
         * Обновить значение элемента объекта
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['LogsServerData'][index] = item;
        },

        /**
         * Добавить значение элемента объекта
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['LogsServerData'].push(item);
        },

        /**
         * Удалить элемент из объекта
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['LogsServerData'] = state['LogsServerData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получение списка лог файлов по пользователю
         * @param {*} username - логин пользователю
         */
        getLogServerData ({ commit, dispatch, getters, rootGetters }, username) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true}); 
                axios({
                    url:  rootGetters.netUrl +'get-log-list?account='+username.username,  
                    method: 'GET', 
                    
                }).then(response => (
                    commit('setArr', {
                        type: 'LogsServerData',
                        items: response.data.map(item => {
                            return {
                                fileName: item.fileName,
                                fileDate: item.fileDate,
                                fileUrl: item.fileUrl, 
                                jsonFileUrl: item.jsonFileUrl,
                            }
                        }),
                    }), 
                     
                        dispatch('loading/isLoading', false, {root:true}),
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Список логов получен.'),
                        resolve()
                )).catch(err => {
                        dispatch('loading/isLoading', false, {root:true}),
                        console.log('ERROR IN logServer.js | getlogServerData : ' + err);
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении списка логов!'),
                        reject(err);
                });
            })
        },
        /**
         * Получение данных по распарсенному файлу лога
         * @param {*} urlJsonLog - ссылка для получения распарсенного лог файла в JSON
         */
        getJsonLogServerData ({ commit, dispatch, getters, rootGetters }, urlJsonLog) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true}); 
                axios({
                    url:  urlJsonLog.urlJsonLog, 
                    method: 'GET', 
                    
                }).then(response => (
                    

                    commit('setArrJson', {
                        items: response.data
                    }), 
                     
                        dispatch('loading/isLoading', false, {root:true}),
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные лога получены.'),
                        resolve()
                )).catch(err => {
                        dispatch('loading/isLoading', false, {root:true}),
                        console.log('ERROR IN logServer.js | jsonLogServerData : ' + err);
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных лога!'),
                        reject(err);
                });
            })
        },
        /**
         * Получение данных по ошибкам за месяц
         * @param {*} data - месяц за который нужен отчет
         */
        getErrorLogServerData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true}); 
                axios({
                    url:  rootGetters.netUrl +'/get-check-log-file?dateLog=' + data.date,  
                    method: 'GET', 
                    
                }).then(response => (
                    commit('setArrError', { 
                        items: response.data
                    }), 
                     
                        dispatch('loading/isLoading', false, {root:true}),
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные лога получены.'),
                        resolve()
                )).catch(err => {
                        dispatch('loading/isLoading', false, {root:true}),
                        console.log('ERROR IN logServer.js | jsonLogServerData : ' + err);
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных лога!'),
                        reject(err);
                });
            })
        },

         getSomeLogs() {
            window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Метод сработал');
         },
         
    },
};

export default LogServer;





// WEBPACK FOOTER //
// ./src/store/modules/logServer.js